"use client"

import { Beaker, Calculator, BookOpen, BookMarked, Palette, Globe } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { SubjectProgress } from "@/components/ui/subject-progress"

export function AcademicPerformance() {
  const subjects = [
    { icon: <Beaker className="w-5 h-5 text-blue-600" />, subject: "Science", percentage: 92, color: "bg-blue-500" },
    {
      icon: <Calculator className="w-5 h-5 text-red-600" />,
      subject: "Mathematics",
      percentage: 85,
      color: "bg-red-500",
    },
    {
      icon: <BookOpen className="w-5 h-5 text-green-600" />,
      subject: "History",
      percentage: 88,
      color: "bg-green-500",
    },
    {
      icon: <BookMarked className="w-5 h-5 text-yellow-600" />,
      subject: "English",
      percentage: 95,
      color: "bg-yellow-500",
    },
    {
      icon: <Palette className="w-5 h-5 text-purple-600" />,
      subject: "Art & Design",
      percentage: 98,
      color: "bg-purple-500",
    },
    {
      icon: <Globe className="w-5 h-5 text-indigo-600" />,
      subject: "Geography",
      percentage: 82,
      color: "bg-indigo-500",
    },
  ]

  return (
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="text-2xl text-slate-900">Academic Performance</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {subjects.map((subject, index) => (
          <SubjectProgress
            key={index}
            icon={subject.icon}
            subject={subject.subject}
            percentage={subject.percentage}
            color={subject.color}
          />
        ))}
      </CardContent>
    </Card>
  )
}
